// src/components/common/LanguageSelector.js
import React, { useState, useRef, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSelector.css';

/**
 * Language selector with globe icon
 * Displays a globe icon that expands to show flag + language options
 */
const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Default to 'en' if language is undefined
  const currentLanguage = language || 'en';

  const languages = [
    { code: 'en', name: 'English', flag: '/flags/US.png' },
    { code: 'ko', name: '한국어', flag: '/flags/KR.png' }
  ];

  // Toggle dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Handle language selection
  const handleLanguageChange = (languageCode) => {
    if (languageCode) {
      changeLanguage(languageCode);
      setIsOpen(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button
        className="language-button"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="Select language"
      >
        <Globe size={20} strokeWidth={1.5} />
      </button>

      {isOpen && (
        <ul className="language-dropdown">
          {languages.map(lang => (
            <li key={lang.code}>
              <button
                className={currentLanguage === lang.code ? 'active' : ''}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <img
                  src={lang.flag}
                  alt={`${lang.name} flag`}
                  className="flag-icon"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                  }}
                />
                <span>{lang.name}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
